fbm.add("commands/mint", ["util/io", "util/screens", "util/pause", "commands/connect", "commands/pip"], function (uio, uscreens, upause, cconnect, cpip) {

    let {
        link, table,
        promptModal,
        type, scroll,
        clear,
        el,
        getScreen,
        addImage,
        addImageToScreen,
        pause,
        clearKey,
        waitForKey,
        getMaxQty, isConnected, isInitialized, power, off, pip
    } = {
        ...uio,
        ...uscreens,
        ...upause,
        ...cconnect,
        ...cpip
    }

    const ape = "/static/images/fba/mint/clean_tv_green.png";
    const imageBaseURL = "https://nftcdn.daz3d.com/fba/props/mint/";

    let processing = false;
    let errors = [];

    let screen;
    let debounce = null;
    let pImage;

    async function typeErrors() {
        if (errors.length === 0) {
            return;
        }

        let messages = ["\nTransaction with Artifact could not be completed. Reason" + ((errors.length > 1) ? "s" : "") + ":"];
        for (let i = 0; i < errors.length; i++) {
            if (errors[i]) {
                messages.push(" - " + errors[i]);
            }
        }
        errors = [];
        await type(messages);
    }

    window.addEventListener("mint_error", async (e) => {
        errors.push(e.detail.error.message);
    })

    window.addEventListener("mint_hash", async (e) => {
        let d = link(dazethutil.transactionLink(e.detail.hash), {
            text: e.detail.hash,
            pre: "🖱 ",
            target: "_blank",
        });

        processing = true;
        await type(["\n", "Receiving Input from Artifact", "New Transaction Detected"], {lineWait: 300});
        await type([d], {processChars: false})
        await type(["Click to view on Etherscan", "\n"], {lineWait: 300});
        await type("Processing, please wait");
        pImage = addImageToScreen(document.querySelector(".terminal"), "/static/images/fba/mint/loading.gif", 'loading').image;
        scroll();

        setTimeout(() => {
            startInterference(ape);
            setTimeout(() => {
                stopInterference();
            }, 10000);
        }, 5000);

        processing = false;

    })

    function startInterference(src) {
        let s = addImage('mint', src, ['enos']);
        screen = s.screen;
    }

    function stopInterference() {
        if (screen) {
            screen.remove();
        }
    }

    async function mintInit(args) {
        await type(["\nPOWERING ARTIFACT", "Connection with artifact established", "Checking for garbage files", "   ! Removed file root/.workspace/.garbage.", "Bootstrapping main security grid", "Reticulating Splines"], {
            lineWait: 300
        });

        await type(["ARTIFACT circuits activated", "exchanging secure connection keys"], {
            lineWait: 300
        });

        startInterference(ape);

        await pause(1);
        await type([`\nCARRIER LOST COMMUNICATING WITH ARTIFACT`, `RE-ESTABLISHING COMMUNICATION`, "\n"], {
            wait: 1,
            lineWait: 250,
            finalWait: 1,
            initialWait: 1
        });
        await pause(1);
        await type([`CONNECTION RESET BY PEER`, `RE-ESTABLISHING COMMUNICATION`, "\n"], {
            wait: 1,
            lineWait: 250,
            finalWait: 1,
            initialWait: 1
        });
        await pause(1);
        stopInterference();
        await type(["Artifact Interface Successful!", "Artifact has requested identification"]);
    }

    async function eamint(skip = false, resetPip = true) {

        const passContract = new window.dazeth.web3.eth.Contract(window.dazContracts["IERC1155BalanceOf"], window.fbaConfig.pass);
        const passCount = await passContract.methods.balanceOf(dazethutil.me(), 0).call();
        if (parseInt(passCount, 10) > 0) {
            if (!skip) {
                await mintInit();
            } else {
                await clear();
            }

            if (!(await isConnected())) {
                await type(["No suitable interface with artifact could be established.", "Please check your Eth Wallet and try again."]);
                return;
            }
            if (!isInitialized()) {
                await power(true);
                return minter();
            }

            try {
                let dm = new FbaMintPass(window.fbaConfig.pass, window.fbaConfig.factory)
                const result = await pip(resetPip);
                return minter(dm, result.prop, result.traits, result.url);
            } catch {
                return abortRetryIgnore();
            }
        }
        await type(["", "No mintpass detected", "Please connect a wallet with a mint pass to continue."]);

        let cb = link("https://nft.coinbase.com/collection/ethereum/0x12509cb9123700a4cb51c0bfac07afa4f37b3628", {
            text: "Buy mintpass on Coinbase",
            pre: "🖱 ",
            target: "_blank"
        });
        let os = link("https://opensea.io/collection/fight-back-apes-mint-pass", {
            text: "Buy mintpass on OpenSea",
            pre: "🖱 ",
            target: "_blank"
        });
        await type([cb, os], {processChars: false});
    }

    function propName(index) {
        index = parseInt(index, 10);
        return props[tokens[index]].Name;
    }

    async function abortRetryIgnore() {
        return new Promise(async resolve => {
            let a = link("javascript:", {
                text: "Abort, I don't want to mint",
                pre: "🖱 ",
                click: async () => {
                    document.getElementById('monitor').classList.remove('preview');
                    await type(["Transaction aborted"]);
                    r.remove();
                    a.remove();
                    await power(false);
                    resolve();
                },
            });

            let r = link("javascript:", {
                text: "Retry, I would like to try minting again",
                pre: "🖱 ",
                click: async () => {
                    document.getElementById('monitor').classList.remove('preview');
                    r.remove();
                    a.remove();
                    await clear();
                    await eamint(true, false);
                    resolve();
                },
            });
            await type([r, a], {processChars: false});
            scroll();
        })
    }

    async function loadData(dm, traitTokenID, traits) {
        const b = {id: 1, wallet: dazethutil.me(), attributes: traits.join(','), prop: traitTokenID};
        return fetch("/nft-api/fba/composite/sign", {
            method: 'POST',
            body: (new URLSearchParams(b)).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(async response => {
            if (!response.ok) {
                throw await response.text();
            }
            return response.json();
        }).then(async result => {
            return dm.data(0, traitTokenID, traits, result.Hash, result.Signature);
        }).catch(async txt => {
            let err = "";
            try {
                err = JSON.parse(txt);
            } catch (e) {
                err = {error: txt};
            }
            window.dispatchEvent(new CustomEvent("mint_error", {detail: {when: "sign", error: err.error}}));
            throw err.error;
        });
    }

    function minter(dm, traitTokenID, traits, imageUrl) {

        const mm = new DazMint(dm);

        return new Promise(async (resolve, reject) => {
            await clear();

            return mm.init().then(async (result) => {
                if (!result.enabled) {
                    reject('not enabled');
                    return;
                }

                let data = await loadData(dm, traitTokenID, traits);

                console.log('Data', data);
                document.getElementById('monitor').classList.add('preview');
                addImageToScreen(document.querySelector(".terminal"), imageUrl, 'preview');
                await type(["Press any key to initialize transaction with artifact"], {
                    lineWait: 250
                });
                await waitForKey([], true);
                document.getElementById('monitor').classList.remove('preview');

                await type(["Transaction initialized"], {
                    lineWait: 250
                });
                if (traitTokenID) {
                    let name = propName(traitTokenID);
                    await type([`Ape Tactile Asset Replication Interface (A.T.A.R.I.) enabled\n> Synthesizing attribute "${name}"`], {
                        lineWait: 250
                    });
                }

                await type(["Please continue this transaction in your wallet."], {
                    lineWait: 250
                });
                scroll();

                processing = true;

                return mm.mint(data).then(async (r) => {
                    if (r) {
                        document.getElementById('monitor').classList.remove('preview');
                        while (processing) {
                            await pause(.1);
                        }
                        stopInterference();
                        pImage && pImage.remove();
                        await type("Processing Complete, Tokens have been minted!\n\n");

                        let d = link("javascript:", {
                            text: "I would like to mint again",
                            pre: "🖱 ",
                            target: "",
                            click: async () => {
                                await eamint(true, true);
                            }
                        });

                        await off(d);
                        setTimeout(() => {
                            resolve();
                        }, 10000);
                    } else {
                        await typeErrors();
                        await abortRetryIgnore();
                        resolve();
                    }
                }, e => {
                    document.getElementById('monitor').classList.remove('preview');
                    pImage && pImage.remove();
                    stopInterference();
                    processing = false;
                    throw e;
                }).catch(e => {
                    document.getElementById('monitor').classList.remove('preview');
                    pImage && pImage.remove();
                    stopInterference();
                    console.error(e);
                    processing = false;
                    throw e;
                })
            }).catch(async (e) => {
                document.getElementById('monitor').classList.remove('preview');
                pImage && pImage.remove();
                stopInterference();
                errors.push(e);
                await typeErrors();
                await abortRetryIgnore();
            });
        });
    }

    return {eamint};

});
